import { Observable } from 'rxjs';
import { Parameter } from '../../../../../@core/interfaces/common/parameter';


export interface CultureMstParameter extends Parameter {
    searchTerm: number;
    orderBy: string;  
}
export interface CultureMst {
    id?:number;
    name:string;  
 
    createdBy:number;
    createdDate:Date;
    updatedBy:number;
    updatedDate:Date
    tenantId:any;
    branchId:any;
      
    parameters?: CultureMstParameter[];
    links?: any;
}

export abstract class CultureMstData { 
    abstract list(url: string): Observable<CultureMst[]>;
    abstract create(url: string,data: CultureMst): Observable<any>;
    abstract update(url: string,data: CultureMst): Observable<any>;
    abstract delete(url: string): Observable<any>;
}
